import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";

import TStyle from "shared/style/tableStyle";
import DefaultButton from "shared/ui/DefaultButton";
import DefaultModal from "shared/ui/DefaultModal";
import useFetch from "shared/model/useFetch";
import useLoginCookie from "shared/model/useLoginCookie";
import useConfrimCookie from "shared/model/useConfrimCookie";

/**
 * @Desc 매니저 매장이용권 보유현황 (New)
 * @Access 프렌차이즈 매니저
 * 
 * @Api 특정 프렌차이즈에 속한 지점(매장) 매니저가 보유한 매장이용권 현황
 * @ResponseData 매니저계정 IDX, 매니저 지점(매장)명, 매니저이름, 매니저 연락처, 매니저가 보유한 매장이용권 수량
 * 
 * @Api 매장 매니저에게 매장 이용권 지급&회수
 * @RequestData 회수[지급(ISSUE), 회수(REVOKE)], 개수, 매니저계정 IDX
 */
const MyFranchiseManagerTicketList = () => {

  const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie();
  const [cookie, , deleteCookie] = useLoginCookie();

  const [managerId, setManagerId] = useState(null);
  const numberRef = useRef();
  const onClicOpenModal = (idx) => setManagerId(idx);

  // 매니저 매장 이용권 보유 현황
  const [fetchResult, fetchRequest] = useFetch();
  useEffect(() => {
    fetchRequest("GET", "/admin/store_ticket/manager/ticket_status");
  }, []);

  // 매니저 이용권 지급
  const giveTicket = async () => {
    if (!managerId) return;
    if (!numberRef.current) return;

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/admin/store_ticket/transfer`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: cookie,
          confirm: confirmCookie,
        },
        body: JSON.stringify({
          type: "ISSUE",
          count: Number(numberRef.current.value),
          storeManagerId: managerId,
        }),
      }
    );

    switch (response.status) {
      case 200:
        window.location.reload()
        break;
      default:
        alert("서버에러가 발생 했습니다.");
    }
  };

  // 매니저 이용권 회수
  const removeTicket = async () => {
    if (!managerId) return;
    if (!numberRef.current) return;

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/admin/store_ticket/transfer`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: cookie,
          confirm: confirmCookie,
        },
        body: JSON.stringify({
          type: "REVOKE",
          count: Number(numberRef.current.value),
          storeManagerId: managerId,
        }),
      }
    );

    switch (response.status) {
      case 200:
        window.location.reload()
        break;
      default:
        alert("서버에러가 발생 했습니다.");
    }
  };

  return (
    <>
      {managerId && (
        <DefaultModal
          title={"지급 & 회수"}
          closeEvent={() => setManagerId(null)}
        >
          <Style.GiveDiv>
            <input placeholder="개수 입력" ref={numberRef} />
            <DefaultButton small fitWidth expandHeight clickEvent={giveTicket}>
              지급
            </DefaultButton>
            <DefaultButton
              small
              fitWidth
              expandHeight
              clickEvent={removeTicket}
            >
              회수
            </DefaultButton>
          </Style.GiveDiv>
        </DefaultModal>
      )}
      <Style.Wrapper>
        <MainHeader>매니저 매장 이용권 보유현황</MainHeader>
        <Style.AreaDiv>
          <TStyle.TableDiv>
            <TStyle.TableRow $title>
              <TStyle.Data $title $size={"short"}>
                IDX
              </TStyle.Data>
              <TStyle.Data $title $size={"expand"}>
                지점명
              </TStyle.Data>
              <TStyle.Data $title $size={"long"}>
                매니저명
              </TStyle.Data>
              <TStyle.Data $title $size={"long"}>
                보유 수량
              </TStyle.Data>
              <TStyle.Data $title $size={"long"}></TStyle.Data>
            </TStyle.TableRow>

            {fetchResult?.data?.items?.map((item) => (
              <TStyle.TableRow key={item.managerId}>
                <TStyle.Data $size={"short"}>{item.managerId}</TStyle.Data>
                <TStyle.Data $size={"expand"}>{item.storeName}</TStyle.Data>
                <TStyle.Data $size={"long"}>{item.managerName}</TStyle.Data>
                <TStyle.Data $size={"long"}>{item.count}</TStyle.Data>
                <TStyle.Data $size={"long"}>
                  <DefaultButton
                    small
                    clickEvent={() => onClicOpenModal(item.managerId)}
                  >
                    이용권 관리
                  </DefaultButton>
                </TStyle.Data>
              </TStyle.TableRow>
            ))}
          </TStyle.TableDiv>
        </Style.AreaDiv>
      </Style.Wrapper>
    </>
  );
};

export default MyFranchiseManagerTicketList;
